<template>
  <div class="container containerTm">
    <div class="containerWrap" :style="containerStyle">
      <div class="headerTop">
        <div class="wrap clearfloat">
          <div class="fl headerTopLeft">欢迎进入甘肃建投土木工程建设集团有限责任公司</div>
          <div class="fr headerTopRight">
            <span><i class="el-icon-s-home"></i> 设为首页</span>
            <span><i class="el-icon-star-on"></i> 添加收藏</span>
          </div>
        </div>
      </div>

      <div class="headerMiddle">
        <div class="wrap clearfloat">
          <div class="fl headerMiddleLeft">
            <a href="/"> <img src="../assets/img/logo_img.jpg" alt=""/></a>
          </div>
          <div class="fr headerMiddleRight">
            <div class="header_search">
              <div>
                <el-input v-model="searchValue" placeholder="请输入标题" style="width: 260px"></el-input>
                <el-button type="submit" class="btn" icon="el-icon-search" @click="handleSearch"></el-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="header">
        <div class="wrap clearfloat">
          <div class="nav_box">
            <ul class="clearfloat">
              <li :class="{ active: active == 0 }">
                <div class="nav_grop">
                  <h2><a href="/">网站首页</a></h2>
                </div>
              </li>
              <li v-for="(item, index) in navList" :key="index" :class="{ active: active == item.id }">
                <div class="nav_grop" @mouseenter="navShow(item.channelId)" @mouseleave="navClose()">
                  <h2 v-if="item.name == '纪检举报'">
                    <a :href="`/report/${item.entTChannelUuid}`">
                      {{ item.name }}
                    </a>
                  </h2>
                  <h2 v-else>
                    <a
                      v-if="item.child.length && item.child[0].url && item.child[0].url !== ''"
                      target="_blank"
                      :href="item.url"
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="item.child.length && (!item.child[0].url || item.child[0].url == '')"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.child[0].entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.child[0].entTChannelUuid}`
                          : `/listPic/${item.child[0].entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                    <a
                      v-if="!item.child.length"
                      :href="
                        item.catalog == 1
                          ? `/listPage/${item.entTChannelUuid}`
                          : item.catalog == 2
                          ? `/list/${item.entTChannelUuid}`
                          : `/listPic/${item.entTChannelUuid}`
                      "
                    >
                      {{ item.name }}
                    </a>
                  </h2>
                  <el-collapse-transition>
                    <div class="nav_down" v-show="navDown == item.channelId">
                      <div class="nav_down_wrap clearfloat" v-show="item.child.length != 0">
                        <p v-for="(item1, index1) in item.child" :key="index1">
                          <a v-if="item1.url && item1.url !== ''" target="_blank" :href="item1.url">
                            {{ item1.name }}
                          </a>
                          <a
                            v-if="!item1.url || item1.url == ''"
                            :href="
                              item1.catalog === 1
                                ? `/listPage/${item1.entTChannelUuid}`
                                : item1.catalog === 2
                                ? `/list/${item1.entTChannelUuid}`
                                : `/listPic/${item1.entTChannelUuid}`
                            "
                          >
                            {{ item1.name }}
                          </a>
                        </p>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="main">
        <router-view></router-view>
      </div>
      <div class="footer">
        <div class="footerWrap">
          <div class="wrap">
            <el-row :gutter="30">
              <el-col :span="16">
                <div class="footerRight">
                  <div class="footerRightInner">
                    <p>
                      联系地址：甘肃省兰州市安宁区北滨河中路1272号
                    </p>
                    <p>
                      <span>联系电话：0931-8324825</span>
                      <span>甘肃建投土木工程建设集团有限责任公司 版权所有</span>
                    </p>
                    <p>
                      <span>网站ICP备案号：<a href="https://beian.miit.gov.cn/" target="_blank">陇ICP备2023002672号-1</a></span>
                      <span><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=62010502000425" target="_blank">甘公网安备 62010502000425号</a></span>
                    </p>
                  </div>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="footerLeft">
                  <div class="footerLeftInner">
                    <div class="pic">
                      <img src="../assets/img/foot_ewm.jpg" alt="" />
                      <p>官方微信</p>
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getNavChannel } from '@/api/common'

export default {
  name: '',
  data() {
    return {
      containerStyle: {},
      viewTop: false,
      txtImg: '',
      searchValue: '',
      active: 0,
      navList: [],
      navListN: [
        {
          channelId: 152,
          parentUuid: '0',
          name: '企业概况',
          catalog: 1,
          entTChannelUuid: '0032',
          url: '/Article?Channel=00320003',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: [
            {
              channelId: 153,
              parentUuid: '0032',
              name: '董事长致辞',
              catalog: 2,
              entTChannelUuid: '00320001',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 154,
              parentUuid: '0032',
              name: '领导班子',
              catalog: 2,
              entTChannelUuid: '00320002',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 155,
              parentUuid: '0032',
              name: '集团简介',
              catalog: 1,
              entTChannelUuid: '00320003',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 156,
              parentUuid: '0032',
              name: '组织机构',
              catalog: 2,
              entTChannelUuid: '00320004',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 157,
              parentUuid: '0032',
              name: '下设机构',
              catalog: 2,
              entTChannelUuid: '00320005',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 158,
              parentUuid: '0032',
              name: '企业资质',
              catalog: 2,
              entTChannelUuid: '00320006',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 159,
              parentUuid: '0032',
              name: '职工天地',
              catalog: 2,
              entTChannelUuid: '00320007',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            }
          ]
        },
        {
          channelId: 160,
          parentUuid: '0',
          name: '新闻动态',
          catalog: 2,
          entTChannelUuid: '0033',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: [
            {
              channelId: 161,
              parentUuid: '0033',
              name: '行政新闻',
              catalog: 2,
              entTChannelUuid: '00330001',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 162,
              parentUuid: '0033',
              name: '党群动态',
              catalog: 2,
              entTChannelUuid: '00330002',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 163,
              parentUuid: '0033',
              name: '党的建设',
              catalog: 2,
              entTChannelUuid: '00330003',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 164,
              parentUuid: '0033',
              name: '内部通告',
              catalog: 2,
              entTChannelUuid: '00330004',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 165,
              parentUuid: '0033',
              name: '公示公告',
              catalog: 2,
              entTChannelUuid: '00330005',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 166,
              parentUuid: '0033',
              name: '基层动态',
              catalog: 2,
              entTChannelUuid: '00330006',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 167,
              parentUuid: '0033',
              name: '甘肃建投要闻',
              catalog: 2,
              entTChannelUuid: '00330007',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 168,
              parentUuid: '0033',
              name: '媒体报道',
              catalog: 2,
              entTChannelUuid: '00330008',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            }
          ]
        },
        {
          channelId: 169,
          parentUuid: '0',
          name: '生产经营',
          catalog: 2,
          entTChannelUuid: '0034',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: []
        },
        {
          channelId: 170,
          parentUuid: '0',
          name: '企业业绩',
          catalog: 3,
          entTChannelUuid: '0035',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: [
            {
              channelId: 171,
              parentUuid: '0035',
              name: '业绩展示',
              catalog: 3,
              entTChannelUuid: '00350001',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 172,
              parentUuid: '0035',
              name: '企业荣誉',
              catalog: 3,
              entTChannelUuid: '00350002',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 173,
              parentUuid: '0035',
              name: '在建工程',
              catalog: 2,
              entTChannelUuid: '00350003',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            }
          ]
        },
        {
          channelId: 174,
          parentUuid: '0',
          name: '党的建设',
          catalog: 2,
          entTChannelUuid: '0036',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: [
            {
              channelId: 175,
              parentUuid: '0036',
              name: '组织部',
              catalog: 2,
              entTChannelUuid: '00360001',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 176,
              parentUuid: '0036',
              name: '宣传部',
              catalog: 2,
              entTChannelUuid: '00360002',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 177,
              parentUuid: '0036',
              name: '纪检部',
              catalog: 2,
              entTChannelUuid: '00360003',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 178,
              parentUuid: '0036',
              name: '工会',
              catalog: 2,
              entTChannelUuid: '00360004',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 179,
              parentUuid: '0036',
              name: '团委',
              catalog: 2,
              entTChannelUuid: '00360005',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            }
          ]
        },
        {
          channelId: 180,
          parentUuid: '0',
          name: '企业文化',
          catalog: 2,
          entTChannelUuid: '0037',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: [
            {
              channelId: 181,
              parentUuid: '0037',
              name: '三建风采',
              catalog: 2,
              entTChannelUuid: '00370001',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 182,
              parentUuid: '0037',
              name: '学习园地',
              catalog: 2,
              entTChannelUuid: '00370002',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 183,
              parentUuid: '0037',
              name: '政策法规',
              catalog: 2,
              entTChannelUuid: '00370003',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 184,
              parentUuid: '0037',
              name: '职工天地',
              catalog: 2,
              entTChannelUuid: '00370004',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            }
          ]
        },
        {
          channelId: 185,
          parentUuid: '0',
          name: '联系我们',
          catalog: 1,
          entTChannelUuid: '0038',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: []
        },
        {
          channelId: 186,
          parentUuid: '0',
          name: '资料中心',
          catalog: 2,
          entTChannelUuid: '0039',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: [
            {
              channelId: 187,
              parentUuid: '0039',
              name: '规定标准',
              catalog: 2,
              entTChannelUuid: '00390001',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 188,
              parentUuid: '0039',
              name: '规章制度',
              catalog: 2,
              entTChannelUuid: '00390002',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            },
            {
              channelId: 189,
              parentUuid: '0039',
              name: '政策法规',
              catalog: 2,
              entTChannelUuid: '00390003',
              url: '',
              fileName: 'http://www.gsjtw.cc',
              isList: 1,
              child: []
            }
          ]
        },
        {
          channelId: 190,
          parentUuid: '0',
          name: '学习园地',
          catalog: 2,
          entTChannelUuid: '0040',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: []
        },
        {
          channelId: 191,
          parentUuid: '0',
          name: '三建风采',
          catalog: 2,
          entTChannelUuid: '0041',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: []
        },
        {
          channelId: 192,
          parentUuid: '0',
          name: '战略发展',
          catalog: 2,
          entTChannelUuid: '0042',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: []
        },
        {
          channelId: 229,
          parentUuid: '0',
          name: '举报中心',
          catalog: 2,
          entTChannelUuid: '0053',
          url: '',
          fileName: 'http://www.gsjtw.cc',
          isList: null,
          child: []
        }
      ],
      navDown: 0
    }
  },
  mounted() {
    this.getPath()
    this.footerImg()
    this.getNavChannel()

    // let url = this.$route.name
    // if (url == 'home') {
    //   this.srollTop()
    // }
    // setTimeout(() => {
    //   this.viewTop = true
    // }, 500);
    // setTimeout(() => {
    //   this.viewTop = false
    // }, 2000)
  },
  created() {},
  watch: {
    $route: 'getPath'
  },
  methods: {
    srollTop() {
      var _this = this
      var heightT
      setTimeout(() => {
        heightT = this.$refs.containerTop.offsetHeight
        _this.containerStyle = {
          marginTop: heightT + 'px'
        }
      }, 500)
      setTimeout(() => {
        _this.containerStyle = {
          marginTop: 0
        }
      }, 3000)
    },
    // 获取导航
    getNavChannel() {
      var _this = this
      let data = {
        applicationUuid: _this.webId
      }
      getNavChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navList = data.slice(0, 9)
          // data.length &&
          //   data.forEach((line, index) => {
          //     if (line.child.length) {
          //       line.url = _this.navList[index].index + '/' + line.child[0].entTChannelUuid
          //     } else {
          //       line.url = _this.navList[index].index + '/' + line.entTChannelUuid
          //     }
          //   })
          // _this.navSubList = [
          //   {
          //     id: 1,
          //     name: '网站首页',
          //     url: '/'
          //   },
          //   ...data
          // ]
        }
      })
    },
    handleSearch() {
      var _this = this
      if (!_this.searchValue || _this.searchValue == '') {
        this.$message({
          message: '请输入关键词',
          type: 'warning'
        })
      } else {
        window.location.href = `/search/${_this.searchValue}`
        // window.open(`/search/${_this.searchValue}`)
      }
    },
    // 二级导航展开
    navShow(d) {
      let _this = this
      // _this[d] = true
      _this.navDown = d
    },
    // 二级导航收起
    navClose() {
      let _this = this
      // _this[d] = false
      _this.navDown = 0
    },
    haddleNav(index, params) {
      var _this = this

      _this.active = index
      _this.$router.push(params.url)
    },
    getPath() {
      var _this = this

      _this.active = _this.$route.meta.index
    },
    footerImg() {
      var _this = this

      _this.txtImg = unescape(
        "%3Cspan id='cnzz_stat_icon_1259563611'%3E%3C/span%3E%3Cscript src='https://s4.cnzz.com/stat.php%3Fid%3D1259563611%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"
      )
      // console.log('txtImg :>> ', _this.txtImg)
    }
  }
}
</script>
<style>
.headerTop {
  line-height: 32px;
  color: #fff;
  background-color: #484647;
  font-size: 14px;
}
.headerTopRight span {
  display: inline-block;
  margin-left: 20px;
  cursor: pointer;
}
.headerTopRight span i {
  font-size: 18px;
  vertical-align: top;
  display: inline-block;
  line-height: 32px;
}
.headerMiddle {
  padding: 30px 0 20px;
}
.headerMiddleLeft img {
  /* width: ; */
  height: auto;
}
.headerMiddleRight {
  margin-top: 28px;
}
.header_search {
  /* width: 380px; */
  height: 32px;
  overflow: hidden;
  float: right;
  position: relative;
  line-height: 32px;
  font-size: 14px;
  color: #585858;
  border: solid 1px #0d65af;
  border-radius: 10px;
}
.header_search input {
  height: 32px;
  overflow: hidden;
  outline: none;
  box-shadow: none;
  line-height: 38px;
  font-size: 14px;
  color: #000;
  border-radius: 0px;
  border: none;
  vertical-align: top;
}
.header_search .el-button {
  width: 40px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  border: none;
  vertical-align: top;
  font-weight: bold;
}
.header {
  text-align: center;
  background-color: #017bce;
  /* background-image: url(../assets/img/header_bg.png); */
  /* background-size: 100% auto;
  background-position: center;
  background-repeat: no-repeat;
  background-color: rgba(13,30,46,.8); */
  /* position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 22; */
}
.headerLogo {
  margin-top: 6px;
  /* margin-bottom: 20px; */
}
.headerLogo img {
  /* width: 360px; */
  height: 46px;
  width: auto;
  vertical-align: middle;
}
.headerNavTxt {
  display: inline-block;
  min-width: 45px;
  color: #fff;
  font-size: 20px;
  letter-spacing: 4px;
  cursor: pointer;
}
.headerNavTxt:hover {
  color: #bc8f68;
}
.main {
  min-height: 500px;
}
.footer {
  background: #484647;
  color: #fff;
}
.footerWrap {
  padding: 30px 0;
  text-align: left;
}
.footerLeft {
  /* padding-top: 46px; */
}
.footerLeft .pic {
  text-align: center;
}
.footerLeft img {
  width: 84px;
  height: auto;
  margin: 0 30px;
}
.footerLeft .txt {
  height: 30px;
  line-height: 30px;
  color: #80b2db;
  font-size: 13px;
}
.footerRight {
  padding-left: 100px;
}
.footerRightTitle {
  font-size: 35px;
  line-height: 35px;
  margin-bottom: 15px;
}
.footerRightInner {
  font-size: 16px;
  line-height: 30px;
}
.footerRightInner span {
  display: block;
}
.footerRightInner a {
  color: #fff;
}
.footerRightInner.bt,
.footerRightInner.bt a {
  color: #80b2db;
}

.nav_box {
  /* height: 38px; */
  /* background-color: #1970b9; */
  line-height: 54px;
}
.nav_box ul li {
  height: 54px;
  line-height: 54px;
  float: left;
  width: 12.5%;
  color: #fff;
  text-align: center;
  position: relative;
}
/* .nav_box ul li a {
  display: block;
} */
.nav_grop {
  /* width: 82px; */
  height: 100%;
  /* margin: 5px auto 0; */
  position: relative;
}
.nav_box ul li h2 {
  text-align: center;
  height: 100%;
  font-size: 16px;
  overflow: hidden;
}
.nav_box ul li h2 a {
  width: 90px;
  height: 54px;
  margin: 0 auto;
  display: block;
  color: #fff;
  border-bottom: 2px solid #017bce;
  box-sizing: border-box;
}
.nav_grop:hover h2 {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.nav_grop:hover h2 a {
  /* background-color: #074378; */
  border-bottom: 2px solid #fff;
}
.nav_box ul li.active h2 a {
  /* background-color: #074378; */
  border-bottom: 2px solid #fff;
}
.nav_down {
  position: absolute;
  width: 100%;
  left: 0;
  top: 64px;
  z-index: 55;
}
.nav_down_wrap {
  padding: 1px 0 0 0;
  border-top: none;
  background-color: rgba(7, 67, 120, 0.6);
}
.nav_down p {
  line-height: 64px;
  text-align: center;
  font-size: 18px;
}
.nav_down p a {
  display: block;
  color: #fff;
}
.nav_down p a:hover {
  background-color: #074378;
}
.header_hd {
  height: 34px;
  line-height: 34px;
  /* background-image: url("../assets/img/st_03.jpg"); */
  background-repeat: repeat-x;
  background-size: auto 100%;
  padding: 0 25px;
  font-size: 12px;
}
.header_top {
  padding: 10px;
}
.mobile {
  display: block;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  border: 1px solid #dedede;
  margin-top: 6px;
  font-size: 12px;
  font-weight: 600;
}

.mobile:hover {
  color: #d60f0f;
}
.user_input {
  display: inline-block;
  width: 120px;
}
.user_l {
  display: inline-block;
  margin-left: 10px;
}
.user_sure {
  margin: 0 4px 0 6px;
  height: 26px;
  line-height: 26px;
  padding: 0 10px;
  border: 1px solid #b6b6b6;
  cursor: pointer;
  vertical-align: top;
  margin-top: 3px;
  background-color: #e9e9e9;
  border-radius: 2px;
}
.user_sure:hover {
  background-color: #dddddd;
}
.user_forget:hover {
  color: #d60f0f;
  text-decoration: underline;
}
.mail_dsz {
  display: inline-block;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  border: 1px solid #dedede;
  margin-top: 6px;
  font-size: 12px;
  color: #d60f0f;
  margin-left: 30px;
}
.mail_dsz:hover {
  border-color: #d60f0f;
}
.user_wrap {
  display: inline-block;
}
.footerBotttom {
  text-align: center;
}
.topLogoMainRight {
  position: absolute;
  width: 380px;
  height: 50px;
  overflow: hidden;
  bottom: 10px;
  right: 0;
}
.topLogoMainRight .el-input__inner {
  background-color: rgba(255, 255, 255, 0.5);
}
.topLogoMainRight .el-button {
  border: none;
}
.topLogoMainRight {
  float: right !important;
}
.footerBottom {
  color: #f7f7f7;
  font-size: 14px;
  padding-top: 20px;
  text-align: center;
  line-height: 24px;
}
.footerBottom a {
  color: #f7f7f7;
  font-size: 16px;
}
/* 土木 */
.containerTm .nav_box {
  line-height: 44px;
}
.containerTm .nav_box ul li {
  width: 10%;
  height: 44px;
  line-height: 44px;
}
.containerTm .nav_box ul li h2 {
  font-weight: bold;
}
.containerTm .nav_down {
  top: 44px;
}
.containerTm .nav_grop h2 a {
  height: 44px;
  width: auto;
  border: none;
}
.containerTm .nav_grop:hover h2 a {
  background-color: #5f8aa7;
  border: none;
}
.containerTm .nav_box ul li.active h2 a {
  background-color: #5f8aa7;
  border: none;
}
.containerTm .nav_down p {
  background-color: #5f8aa7;
  height: 36px;
  line-height: 36px;
  border-top: 1px #C6B4AC solid;
  font-size: 14px;
}
.containerTm .nav_down p a:hover {
  background-color: #017bce;
}
.containerTm .footer {
  background-color: #0062b3;
}
.containerTm .footerRightInner span {
  display: inline-block;
  margin-right: 20px;
}
.containerTm .footerLeft p {
  font-size: 14px;
  line-height: 30px;
}
</style>
